// Mirrors public/zingNotificationFrames.js (CRA can't import from public/);
// zingNotifications.test.js asserts the two stay in sync.
export const NOTI_ID = {
    FALL: 0x65,
    BATTERY: 0x66,
    MOTOR_LINK: 0x67,
    SD_CARD: 0x68,
}
export const NOTI_DATA_LENGTH = {
    [NOTI_ID.FALL]: 1,
    [NOTI_ID.BATTERY]: 1,
    [NOTI_ID.MOTOR_LINK]: 2,
    [NOTI_ID.SD_CARD]: 0,
}

export const ZING_MOTOR_COUNT = 16
export const BATTERY_STALE_MS = 150000

// Explicitly supports Zing 2.0, 2.1, and 2.2+ (Humanoid series).
// Devices whose firmware never sends notification frames simply never produce any.
export const isZingNotificationDevice = (connectedDevice, deviceVersion) => {
    const dev =
        connectedDevice ||
        (typeof sessionStorage !== 'undefined'
            ? sessionStorage.getItem('connectedDevice')
            : null)
    if (dev !== 'Humanoid') return false

    const version =
        deviceVersion ||
        (typeof sessionStorage !== 'undefined'
            ? sessionStorage.getItem('deviceVersion')
            : null)
    if (!version) return true

    const major = parseInt(String(version).split('.')[0], 10)
    return isNaN(major) || major >= 2
}

// DATA is a uint16_t little-endian; a SET bit marks a servo that is linked
// (responding) and a CLEAR bit a faulty one. bit N is servo ID N + 1.
// Verified on hardware: unplugging servo 6 sends every bit set except bit 5.
export const decodeMotorLinkMask = (data) => {
    const mask = (data[0] | (data[1] << 8)) & 0xffff
    const faultyIds = []
    for (let bit = 0; bit < ZING_MOTOR_COUNT; bit++) {
        if (!(mask & (1 << bit))) faultyIds.push(bit + 1)
    }
    return { mask, faultyIds }
}

// Turns a raw { nid, data } into an event, or null if unknown/malformed.
export const decodeNotification = (raw) => {
    if (!raw || !Array.isArray(raw.data)) return null
    const expected = NOTI_DATA_LENGTH[raw.nid]
    if (expected === undefined || raw.data.length !== expected) return null

    switch (raw.nid) {
        case NOTI_ID.FALL:
            if (raw.data[0] !== 0 && raw.data[0] !== 1) return null
            return { type: 'fall', fallen: raw.data[0] === 1 }
        case NOTI_ID.BATTERY:
            if (raw.data[0] > 100) return null
            return { type: 'battery', percent: raw.data[0] }
        case NOTI_ID.MOTOR_LINK:
            return { type: 'motorLink', ...decodeMotorLinkMask(raw.data) }
        case NOTI_ID.SD_CARD:
            return { type: 'sdCard' }
        default:
            return null
    }
}
